import { decodeJwtPayload } from '~/utils/decodeJwtPayload';
import { normalizeEmail } from '~/utils/normalizeEmail';
const GMAIL_DOMAINS = [
    'gmail.com',
    'googlemail.com'
];
const normalizeForEnhancedConversions = (email)=>{
    const normalizedEmail = normalizeEmail(email);
    const atIndex = normalizedEmail.lastIndexOf('@');
    const domain = normalizedEmail.slice(atIndex + 1);
    if (atIndex < 0 || !GMAIL_DOMAINS.includes(domain)) return normalizedEmail;
    const username = normalizedEmail.slice(0, atIndex).split('+')[0].replace(/\./g, '');
    return "".concat(username, "@").concat(domain);
};
// WHY: GTM maps `email` to Google Ads' sha256_email_address, which only matches a hash of the address normalized as Google does: trimmed, lower-cased, and for gmail.com/googlemail.com with dots and any '+tag' removed from the username.
export async function gtmHashedEmailField(sha256Hex, email) {
    const normalizedEmail = email == null ? '' : normalizeForEnhancedConversions(email);
    if (!normalizedEmail) return {};
    // WHY: an unhashable email (no crypto.subtle on insecure origins) must never block or drop the sign-in it annotates.
    try {
        return {
            email: await sha256Hex(normalizedEmail)
        };
    } catch (unused) {
        return {};
    }
}
// WHY: the sign-in success event fires before the session's user info loads, so the provider's ID token is the only email source.
export function emailFromIdToken(idToken) {
    var _decodeJwtPayload;
    const email = (_decodeJwtPayload = decodeJwtPayload(idToken)) === null || _decodeJwtPayload === void 0 ? void 0 : _decodeJwtPayload.email;
    return typeof email === 'string' ? email : null;
}
